import api from '@/src/api';

export default function(event, properties = {}) {
  return api.post("/tracking", { event, properties })
};
